// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FolderAddOutlinedSvg from "@ant-design/icons-svg/es/asn/FolderAddOutlined";
import AntdIcon from '../components/AntdIcon';

var FolderAddOutlined = function FolderAddOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FolderAddOutlinedSvg
  }));
};

FolderAddOutlined.displayName = 'FolderAddOutlined';
export default React.forwardRef(FolderAddOutlined);